import { render, staticRenderFns } from "./DetailQuickQuote.vue?vue&type=template&id=35e37f25&scoped=true&lang=html&"
import script from "./DetailQuickQuote.vue?vue&type=script&lang=js&"
export * from "./DetailQuickQuote.vue?vue&type=script&lang=js&"
import style0 from "./DetailQuickQuote.vue?vue&type=style&index=0&id=35e37f25&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e37f25",
  null
  
)

export default component.exports